import { render } from "./ProductsCarousel.vue?vue&type=template&id=4b24b5c1"
import script from "./ProductsCarousel.vue?vue&type=script&lang=js"
export * from "./ProductsCarousel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__